export const MAIN_INPUT_HOTKEY_SCOPE_PROPS = {
    "data-code-main-input-hotkeys": "true",
} as const
export const INPUT_FOCUS_HOTKEYS = "meta+l,ctrl+l"

const MAIN_INPUT_HOTKEY_SCOPE_SELECTOR = "[data-code-main-input-hotkeys='true']"
const CONTENT_EDITABLE_SELECTOR = "[contenteditable='true'],[contenteditable='plaintext-only']"

export function isMainInputHotkeyScopeEvent(event: KeyboardEvent): boolean {
    const target = event.target
    if (!(target instanceof Element)) return false
    return target.closest(MAIN_INPUT_HOTKEY_SCOPE_SELECTOR) !== null
}

export function shouldIgnoreMainInputContentEditableHotkey(event: KeyboardEvent): boolean {
    const target = event.target
    if (!(target instanceof Element)) return false

    const inContentEditable = (target instanceof HTMLElement && target.isContentEditable) || target.closest(CONTENT_EDITABLE_SELECTOR) !== null
    return inContentEditable && !isMainInputHotkeyScopeEvent(event)
}
